import {
  WordElementCleaner,
  ParagraphCleaner,
  WhitespaceCleaner,
} from './HtmlSanitizer';
import {
  BulletListConverter,
  NumberedListConverter,
} from './HtmlListConverter';
import { CMSTableConverter } from './CMSTableConverter';

/**
 * Main Word content cleaner that orchestrates all cleaning operations
 * Follows the same workflow as the original cleanWordHtml function
 */
export class WordCleaner {
  constructor() {
    this.elementCleaner = new WordElementCleaner();
    this.paragraphCleaner = new ParagraphCleaner();
    this.whitespaceCleaner = new WhitespaceCleaner();
    this.bulletConverter = new BulletListConverter();
    this.numberedConverter = new NumberedListConverter();
    this.cmsTableConverter = new CMSTableConverter();
  }

  clean(html) {
    if (!html || typeof html !== 'string') {
      return html;
    }

    try {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;

      // Step 1: Remove Word-specific elements and attributes
      this.elementCleaner.clean(tempDiv);

      // Step 2: Clean empty paragraphs
      this.paragraphCleaner.clean(tempDiv);

      // Step 3: Convert hyphen lists to HTML lists
      this.bulletConverter.convertHyphenListsToHtml(tempDiv);

      // Step 3.5: Convert numbered lists to HTML lists
      this.numberedConverter.convertNumberedListsToHtml(tempDiv);

      // Step 4: Remove excessive whitespace and formatting
      this.whitespaceCleaner.clean(tempDiv);

      // Step 5: Convert Slate tables to full CMS format
      this.cmsTableConverter.convertSlateTableToCMSFormat(tempDiv);

      return tempDiv.innerHTML;
    } catch (error) {
      // Return original HTML if cleaning fails
      return html;
    }
  }
}
